module.exports = "/_next/static/images/ScoreMeter3@2x-8de9effcfca29e53985d06d64a8683a5.webp";